import { getInstance as getBootstrap } from 'utils/bootstrap';

/**
 * Get the bootstrap data that PHP left for us
 */
const bootstrap = getBootstrap();

export const getEventPageUrl = () => bootstrap.get('event.previewUrl', '/');

export const getCanonicalEventPageUrl = () => bootstrap.get('event.canonicalEventlUrl', '/');
export const eventHasCustomDomain = () => !!bootstrap.get('event.eventHasCustomdomain', false);

export const getEventPageRegisterUrl = () => {
    const eventPageUrl = getEventPageUrl();
    const openRegistrationModalParam = 'autoopen=1';
    const params = eventPageUrl.split('?');

    // check if ?preview is added (local)
    const connector = params.length > 1 ? '&' : '/?';

    return `${eventPageUrl}${connector}${openRegistrationModalParam}`;
};

export const getEventPageContactOrganizerUrl = () => `${getEventPageUrl()}#contact-organizer`;

const javaScriptProtocol =
    // eslint-disable-next-line max-len, no-control-regex
    /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/gi;

export const softSanitizeUrl = (url = '') => url.replace(javaScriptProtocol, '');

export const isValidUrl = (url = '') => {
    try {
        const { protocol } = new URL(url);
        return protocol.startsWith('https:');
    } catch (error) {
        return false;
    }
};

export const appendGuestAccessHash = (url, guestAccessHash) => {
    const { pathname, origin } = window?.location || {};
    const pathnameWithStrippedEndSlash = (pathname || '').replace(/\/$/, '');
    const link = new URL(`${origin}${pathnameWithStrippedEndSlash}${url}`);
    link.searchParams.append('guest-access-hash', guestAccessHash);

    return link.toString();
};

const isRegistrationReady = (sessionRegistration, sessions) =>
    sessionRegistration?.isSessionRegistrationReady && sessions;

const filterSessions = (guestSessionRegistrationStatuses, sessions) =>
    sessions.filter(
        (session) =>
            Object.prototype.hasOwnProperty.call(guestSessionRegistrationStatuses, session.id) ||
            session.registrationRequired === false,
    );

export const getRegisteredSessions = (sessionRegistration, sessions) => {
    if (!isRegistrationReady(sessionRegistration, sessions)) {
        return [];
    }

    const { guestSessionRegistrationStatuses = {} } = sessionRegistration;
    return filterSessions(guestSessionRegistrationStatuses, sessions);
};

export const getRegisteredSessionsStatus = (sessionRegistration, sessions) => {
    if (!isRegistrationReady(sessionRegistration, sessions)) {
        return [];
    }
    const { guestSessionRegistrationStatuses = {} } = sessionRegistration;
    return sessions.map((session) => {
        const registrationStatus = guestSessionRegistrationStatuses[session.id] || null;

        const isRegisteredOrNotRequired = registrationStatus !== null || !session.registration_required;
        return { ...session, registrationStatus, isRegisteredOrNotRequired };
    });
};
